module.exports = require('./../dist/svg-components/gizmo/Search');